module.exports = __webpack_public_path__ + "img/index-m-slide1.d507f3a3.jpg";